import axios from '../../utils/request';

const getDefaultGeneralState = () => {
    return {
        sports: { status: false, data: [] },
        services: { status: false, data: [] },
        player_combinations: { status: false, data: [] },
        qportalServices: { status: false, data: [] },
        priohubServices: { status: false, data: [] },
        qportalVenues: { status: false, data: [] },
        priohubVenues: { status: false, data: [] },
        cities: { status: false, data: [] },
        countries: { status: false, data: [] },
        venues: { status: false, data: [] },
    };
};

const state = getDefaultGeneralState();

const getters = {
    getSports: (state) => state.sports,
    getServices: state => state.services,
    getPlayerCombinations: state => state.player_combinations,
    getCountries: state => state.countries,
    getCities: state => state.cities,
    getVenues: state => state.venues,
    getQportalServices: state => state.qportalServices,
    getPriohubServices: state => state.priohubServices,
    getQportalVenues: state => state.qportalVenues,
    getPriohubVenues: state => state.priohubVenues
};

const actions = {
    SportsList({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("admin/sports").then(
                (response) => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit("setSports", data);
                        resolve(response);
                    }
                    reject(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    loadServices({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('settings/services').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setServices', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadPlayerCombinations({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('settings/player-combinations').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setPlayerCombinations', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadCities({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('cities').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setCities', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadCountries({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('public/countries').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setCountries', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadUsers({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('users/list').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setUsers', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadQportalServices({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('settings/qportal-services').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;

                        commit('setQportalServices', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadQportalVenues({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('settings/qportal-venues').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setQportalVenues', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadPriohubServices({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('settings/priohub-services').then(
                response => {
                    //  if (response.status == 200 && response.data.status == true) {
                    let data = response.data.data;
                    commit('setPriohubServices', data);
                    resolve(response);
                    //  }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadPriohubVenues({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('settings/priohub-venues').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setPriohubVenues', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    loadVenues({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('venues').then(
                response => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit('setVenues', data);
                        resolve(response);
                    }
                    reject(response);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
};
/* eslint-disable */
const mutations = {
    setSports: (state, data) => {
        state.sports.data = data;
        state.sports.status = true;
    },
    setServices: (state, data) => {
        state.services.data = data;
        state.services.status = true;
    },
    setPlayerCombinations: (state, data) => {
        state.player_combinations.data = data;
        state.player_combinations.status = true;
    },
    setCountries: (state, data) => {
        state.countries.data = data;
        state.countries.status = true;
    },
    setCities: (state, data) => {
        state.cities.data = data;
        state.cities.status = true;
    },
    setVenues: (state, data) => {
        state.venues.data = data;
        state.venues.status = true;
    },
    setQportalServices: (state, data) => {
        state.qportalServices.data = data;
        state.qportalServices.status = true;
    },
    setPriohubServices: (state, data) => {
        state.priohubServices.data = data;
        state.priohubServices.status = true;
    },
    setQportalVenues: (state, data) => {
        state.qportalVenues.data = data;
        state.qportalVenues.status = true;
    },
    setPriohubVenues: (state, data) => {
        state.priohubVenues.data = data;
        state.priohubVenues.status = true;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};